@if (isAppReady()) {
  <app-header></app-header>
  <main class="app-content">
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </main>
  <app-footer></app-footer>
} @else {
  <section class="app-loading" aria-busy="true" aria-live="polite">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <p class="loading-message">Preparing your workspace…</p>
  </section>
}

